/**
 * Sorted list of all Chilean comuna names.
 *
 * Mirrors apps/saas_back/src/assets/global/chile-region-codes.csv (column 'Nombre Comuna'),
 * de-duplicated and sorted with es-CL locale. Keep in sync when the CSV changes.
 */
export const CHILE_COMMUNES: readonly string[] = [
  'Algarrobo',
  'Alhué',
  'Alto Biobío',
  'Alto Hospicio',
  'Alto del Carmen',
  'Ancud',
  'Andacollo',
  'Angol',
  'Antofagasta',
  'Antuco',
  'Antártica',
  'Arauco',
  'Arica',
  'Aysén',
  'Buin',
  'Bulnes',
  'Cabildo',
  'Cabo de Hornos',
  'Cabrero',
  'Calama',
  'Calbuco',
  'Caldera',
  'Calera',
  'Calera de Tango',
  'Calle Larga',
  'Camarones',
  'Camiña',
  'Canela',
  'Carahue',
  'Cartagena',
  'Casablanca',
  'Castro',
  'Catemu',
  'Cauquenes',
  'Cañete',
  'Cerrillos',
  'Cerro Navia',
  'Chaitén',
  'Chanco',
  'Chañaral',
  'Chiguayante',
  'Chile Chico',
  'Chillán',
  'Chillán Viejo',
  'Chimbarongo',
  'Cholchol',
  'Chonchi',
  'Chépica',
  'Cisnes',
  'Cobquecura',
  'Cochamó',
  'Cochrane',
  'Codegua',
  'Coelemu',
  'Coihueco',
  'Coinco',
  'Colbún',
  'Colchane',
  'Colina',
  'Collipulli',
  'Coltauco',
  'Combarbalá',
  'Concepción',
  'Conchalí',
  'Concón',
  'Constitución',
  'Contulmo',
  'Copiapó',
  'Coquimbo',
  'Coronel',
  'Corral',
  'Coyhaique',
  'Cunco',
  'Curacautín',
  'Curacaví',
  'Curaco de Vélez',
  'Curanilahue',
  'Curarrehue',
  'Curepto',
  'Curicó',
  'Dalcahue',
  'Diego de Almagro',
  'Doñihue',
  'El Bosque',
  'El Carmen',
  'El Monte',
  'El Quisco',
  'El Tabo',
  'Empedrado',
  'Ercilla',
  'Estación Central',
  'Florida',
  'Freire',
  'Freirina',
  'Fresia',
  'Frutillar',
  'Futaleufú',
  'Futrono',
  'Galvarino',
  'General Lagos',
  'Gorbea',
  'Graneros',
  'Guaitecas',
  'Hijuelas',
  'Hualaihué',
  'Hualañé',
  'Hualpén',
  'Hualqui',
  'Huara',
  'Huasco',
  'Huechuraba',
  'Illapel',
  'Independencia',
  'Iquique',
  'Isla de Maipo',
  'Isla de Pascua',
  'Juan Fernández',
  'La Cisterna',
  'La Cruz',
  'La Estrella',
  'La Florida',
  'La Granja',
  'La Higuera',
  'La Ligua',
  'La Pintana',
  'La Reina',
  'La Serena',
  'La Unión',
  'Lago Ranco',
  'Lago Verde',
  'Laguna Blanca',
  'Laja',
  'Lampa',
  'Lanco',
  'Las Cabras',
  'Las Condes',
  'Lautaro',
  'Lebu',
  'Licantén',
  'Limache',
  'Linares',
  'Litueche',
  'Llanquihue',
  'Llay Llay',
  'Lo Barnechea',
  'Lo Espejo',
  'Lo Prado',
  'Lolol',
  'Loncoche',
  'Longaví',
  'Lonquimay',
  'Los Alamos',
  'Los Andes',
  'Los Angeles',
  'Los Lagos',
  'Los Muermos',
  'Los Sauces',
  'Los Vilos',
  'Lota',
  'Lumaco',
  'Machalí',
  'Macul',
  'Maipú',
  'Malloa',
  'Marchihue',
  'Mariquina',
  'María Elena',
  'María Pinto',
  'Maule',
  'Maullín',
  'Mejillones',
  'Melipeuco',
  'Melipilla',
  'Molina',
  'Monte Patria',
  'Mostazal',
  'Mulchén',
  'Máfil',
  'Nacimiento',
  'Nancagua',
  'Natales',
  'Navidad',
  'Negrete',
  'Ninhue',
  'Nogales',
  'Nueva Imperial',
  "O'Higgins",
  'Olivar',
  'Ollagüe',
  'Olmué',
  'Osorno',
  'Ovalle',
  'Padre Hurtado',
  'Padre Las Casas',
  'Paiguano',
  'Paillaco',
  'Paine',
  'Palena',
  'Palmilla',
  'Panguipulli',
  'Panquehue',
  'Papudo',
  'Paredones',
  'Parral',
  'Pedro Aguirre Cerda',
  'Pelarco',
  'Pelluhue',
  'Pemuco',
  'Pencahue',
  'Penco',
  'Peralillo',
  'Perquenco',
  'Petorca',
  'Peumo',
  'Peñaflor',
  'Peñalolén',
  'Pica',
  'Pichidegua',
  'Pichilemu',
  'Pinto',
  'Pirque',
  'Pitrufquén',
  'Placilla',
  'Portezuelo',
  'Porvenir',
  'Pozo Almonte',
  'Primavera',
  'Providencia',
  'Puchuncaví',
  'Pucón',
  'Pudahuel',
  'Puente Alto',
  'Puerto Montt',
  'Puerto Octay',
  'Puerto Varas',
  'Pumanque',
  'Punitaqui',
  'Punta Arenas',
  'Puqueldón',
  'Purranque',
  'Purén',
  'Putaendo',
  'Putre',
  'Puyehue',
  'Queilén',
  'Quellón',
  'Quemchi',
  'Quilaco',
  'Quilicura',
  'Quilleco',
  'Quillota',
  'Quillón',
  'Quilpué',
  'Quinchao',
  'Quinta Normal',
  'Quinta de Tilcoco',
  'Quintero',
  'Quirihue',
  'Rancagua',
  'Ranquil',
  'Rauco',
  'Recoleta',
  'Renaico',
  'Renca',
  'Rengo',
  'Requínoa',
  'Retiro',
  'Rinconada',
  'Romeral',
  'Río Bueno',
  'Río Claro',
  'Río Hurtado',
  'Río Ibáñez',
  'Río Negro',
  'Río Verde',
  'Saavedra',
  'Sagrada Familia',
  'Salamanca',
  'San Antonio',
  'San Bernardo',
  'San Carlos',
  'San Clemente',
  'San Esteban',
  'San Fabián',
  'San Felipe',
  'San Fernando',
  'San Gregorio',
  'San Ignacio',
  'San Javier',
  'San Joaquín',
  'San José de Maipo',
  'San Juan de la Costa',
  'San Miguel',
  'San Nicolás',
  'San Pablo',
  'San Pedro',
  'San Pedro de Atacama',
  'San Pedro de la Paz',
  'San Rafael',
  'San Ramón',
  'San Rosendo',
  'San Vicente',
  'Santa Bárbara',
  'Santa Cruz',
  'Santa Juana',
  'Santa María',
  'Santiago',
  'Santo Domingo',
  'Sierra Gorda',
  'Talagante',
  'Talca',
  'Talcahuano',
  'Taltal',
  'Temuco',
  'Teno',
  'Teodoro Schmidt',
  'Tierra Amarilla',
  'Tiltil',
  'Timaukel',
  'Tirúa',
  'Tocopilla',
  'Toltén',
  'Tomé',
  'Torres del Paine',
  'Tortel',
  'Traiguén',
  'Treguaco',
  'Tucapel',
  'Valdivia',
  'Vallenar',
  'Valparaíso',
  'Vichuquén',
  'Victoria',
  'Vicuña',
  'Vilcún',
  'Villa Alegre',
  'Villa Alemana',
  'Villarrica',
  'Vitacura',
  'Viña del Mar',
  'Yerbas Buenas',
  'Yumbel',
  'Yungay',
  'Zapallar',
  'Ñiquén',
  'Ñuñoa',
];
